import { WellLayerDTO } from 'business/models/Models';

export enum sortingOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}
export type WellInfoAllSortDataType = {
  [k: number]: { selectedValue: string; sortOrder: sortingOrder };
};
export type DropsCheckboxStateType = { [k: number]: boolean };
export type FindDropsListType = { [k: string]: string | number | WellLayerDTO[] }[];
export type WellInfoItemType = { [k: string]: string | number | WellLayerDTO[] };
export type GeneralObjectType = { [k: string]: string | number | boolean };
export const dropDownSelectorKeyValueTitle = {
  plateNumber: 'Plates',
  wellNumber: 'Wells',
  dropNumber: 'Drops',
  select: 'Select',
};

export enum ScoreGroupType {
  All = 'All Scores',
  Auto = 'Auto Scores',
  Manual = 'Manual Scores',
}

export enum HitType {
  All,
  Any,
}
